import React from "react";
import "./Administration.css";

function Administration() {
  return (
    <div className="finances-administration">
      <div className="finances-administration__placeholder">
        <div className="finances-administration__title">Раздел «Администрирование» в разработке</div>
        <div className="finances-administration__text">Здесь скоро появится функционал раздела</div>
      </div>
    </div>
  );
}

export default Administration;
